import { Button } from '@mui/material';

export * from './ShareButtonNative';
export * from './ShareButtonWeb';

export function ShareButton({
  sx,
  label,
  icon,
  onShare,
}: {
  sx?: React.CSSProperties;
  label?: string;
  icon?: React.ReactNode;
  onShare?: (e: React.MouseEvent) => void;
}) {
  return (
    <Button
      variant="contained"
      // eslint-disable-next-line react/jsx-no-undef
      startIcon={icon}
      fullWidth
      onClick={onShare}
      sx={{
        ...sx,
        // Based on the button that set to 100% height, it's no a proper size for this button,
        // so we set the height to 48px for temporary solution,  should check if height 100% is necessary later.
      }}
    >
      {label}
    </Button>
  );
}
